module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('label', {
    staticClass: "tech grey"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "filename-input",
    on: {
      "click": _vm.sFiles
    }
  }, [_c('input', {
    staticClass: "input-field",
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.filename
    }
  }), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 25 25"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#919191",
      "stroke-width": "1.5",
      "d": "M20.948 10.809l.152-.152a4.783 4.783 0 0 0 0-6.757 4.783 4.783 0 0 0-6.757 0L3.91 14.335a4.783 4.783 0 0 0 0 6.756 4.783 4.783 0 0 0 6.756 0l7.052-7.056a2.609 2.609 0 0 0 0-3.687 2.609 2.609 0 0 0-3.687 0l-7.39 7.391"
    }
  })])]), _c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.files)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7826935e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/FileInput.vue
// module id = 46
// module chunks = 7